<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Reporte de comprobantes
          </a>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">

        <div class="form-group col-lg-3">
          <label>Seleccionar fechas</label>
          <div class="input-group">
            <span class="input-group-prepend">
              <span class="input-group-text">
                <i class="far fa-calendar-alt"></i>
              </span>
            </span>
            <input type="text" id="date_range" class="form-control">
          </div>
        </div>

        <div class="form-group col-lg-3">
          <label>Tipo Comprobante</label>
          <select class="form-control" id="typeVoucherSelected" [(ngModel)]="typeVoucherSelected"
            (change)="changeTypeVoucher()">
            <option [ngValue]="null">TODOS</option>
            <option *ngFor="let item of typevouchers" [value]="item.id">{{ item.description }} </option>
          </select>
        </div>

        <div class="form-group col-lg-2">
          <label>Serie</label>
          <select class="form-control" id="serieSelected" [(ngModel)]="serieSelected">
            <option [ngValue]="null">TODOS</option>
            <option *ngFor="let item of series" [value]="item.series">{{ item.series }} </option>
          </select>
        </div>

        <div class="form-group col-lg-2">
          <label>Moneda</label>
          <select class="form-control" id="currencySelected" [(ngModel)]="currencySelected">
            <option *ngFor="let item of currencies" [value]="item.id">{{ item.description }} </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <button type="button" class="btn btn-light m-r-10" title="Actualizar" (click)="refresh()">
            <i class="fas fa-undo"></i></button>
          <button class="btn btn-primary " (click)="generateReport()">Filtrar datos <i
              class="fas fa-search m-l-5"></i></button>

          <button class="btn btn-outline-secondary dropdown-toggle float-right" type="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Exportar
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item pointer" (click)="downloadExcel()"><i class="far fa-file-excel text-success m-r-5"></i>Formato
              Excel</a>
          </div>
        </div>
      </div>

      <div class="card m-b-30 m-t-20">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead class="thead-default">
                    <tr>
                      <th>Comprobante</th>
                      <th>Oficina</th>
                      <th>Envío</th>
                      <th>Cliente</th>
                      <th>Moneda</th>
                      <th>Total</th>
                      <th>Fecha</th>
                      <th class="text-center">E.Sunat<span data-toggle="tooltip" data-placement="right"
                          data-original-title="Estado del comprobante respuesta facturador Sunat"><i
                            class="fas fa-info-circle f-s-12 m-l-5"></i></span></th>
                      <th class="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="items.length == 0">
                      <td colspan="2"><span>No se encontraron registros</span></td>
                    </ng-container>
                    <ng-container *ngIf="items.length > 0">
                      <tr [ngClass]="{'text-danger': item.date_repayment != null }"
                        *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                        <td>
                          {{item.typevoucher}}
                          <p class="f-s-12 m-b-0">{{item.nro_voucher}}</p>
                        </td>
                        <td>
                          {{item.branchoffice_data.description}}
                          <ng-container *ngIf="item.branchoffice_data.ruc != null">
                            <p class="f-s-10 m-b-0">{{item.branchoffice_data.ruc}}</p>
                          </ng-container>
                        </td>
                        <!-- <td>
                              <a class="grid__link info">
                                {{item.sale_code}}
                              </a>
                            </td> -->
                        <td>
                          <ng-container *ngIf="item.billing_external_id == null">
                            <span class="badge badge-warning f-s-10">Pendiente</span>
                          </ng-container>
                          <ng-container *ngIf="item.billing_external_id != null">
                            <span class="badge badge-info f-s-10">Enviado</span>
                          </ng-container>
                        </td>
                        <td>
                          <p class="m-b-0">{{item.client_data.fullname}}</p>
                          <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} : {{item.client_data.document}}
                          </p>
                        </td>
                        <td>{{item.currency.description}}</td>
                        <td>{{item.amount}}</td>
                        <td>
                          {{item.date_movement}}
                        </td>
                        <td class="text-center">
                          <ng-container *ngIf="item.billing_external_id != null">

                            <!-- ✅ Factura generada correctamente -->
                            <ng-container *ngIf="item.billing_response_array?.response">
                              <!-- Como response es un objeto, solo verificamos si existe -->
                              <button style="padding: 3px 6px;" type="button" class="btn btn-sm m-l-5 f-s-12"
                                data-html="true" data-container="body" data-toggle="popover" data-placement="right"
                                [attr.data-content]="
                                    '<div>
                                      <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Estado</span>: 
                                        <span class=\'bold f-s-9 badge ' + item.billing_response_array.state_type.bg_class + '\'>'
                                          + item.billing_response_array.data.state_type_description +
                                        '</span>
                                      </p>
                                      <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Código</span>: '
                                        + item.billing_response_array.response.code + '</p>
                                      <p class=\'m-b-0 f-s-10\'><span class=\'bold\'>Descripción</span>: '
                                        + item.billing_response_array.response.description + '</p>
                                    </div>'
                                  ">
                                <span
                                  class="badge {{item.billing_response_array.state_type.bg_class}}">{{item.billing_response_array.data.state_type_description}}</span><i
                                  class="fas fa-info-circle m-l-5"></i>
                              </button>
                            </ng-container>

                            <!-- ✅ Documento dado de baja -->
                            <ng-container *ngIf="item.billing_unsubscribe != null">
                              <ng-container *ngIf="item.billing_unsubscribe_array?.response">
                                <button style="padding: 3px 6px;" type="button"
                                  class="btn btn-outline-danger btn-sm m-l-5 f-s-12" data-html="true"
                                  data-container="body" data-toggle="popover" data-placement="right"
                                  [attr.data-content]="
                                      '<div>
                                        <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Estado</span>: 
                                          <span class=\'bold f-s-9 badge badge-danger m-t-10\'>De baja</span>
                                        </p>
                                        <p class=\'m-b-2 f-s-10\'><span class=\'bold\'>Código</span>: '
                                          + item.billing_unsubscribe_array.response.code + '</p>
                                        <p class=\'m-b-0 f-s-10\'><span class=\'bold\'>Descripción</span>: '
                                          + item.billing_unsubscribe_array.response.description + '</p>
                                      </div>'
                                    ">
                                  <i class="fas fa-list-alt"></i>
                                </button>
                              </ng-container>
                            </ng-container>

                          </ng-container>

                          <!-- Sin documento -->
                          <ng-container *ngIf="item.billing_external_id == null">
                            -
                          </ng-container>
                        </td>
                        <td class="text-center">
                          <ng-container *ngIf="item.date_repayment == null">
                            <span class="badge">Activo</span>
                          </ng-container>
                          <ng-container *ngIf="item.date_repayment != null">
                            <span class="badge badge-danger">Anulado</span>
                          </ng-container>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="row content_pagination">
                <div class="col-lg-4">
                  <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.
                  </p>
                </div>
                <div class="text-right col-lg-8">
                  <ng-container *ngIf="items.length > 0">
                    <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
